export const courierList = [
  { label: "Correos Express", value: "CEX" },
  { label: "CTT Express", value: "CTT" },
  { label: "UPS", value: "UPS" },
  { label: "SEUR", value: "SEUR" },
  { label: "GLS", value: "GLS" },
  { label: "MRW", value: "MRW" },
  { label: "FedEx", value: "FEDEX" },
  { label: "Ontime", value: "ONTIME" },
  { label: "DHL Parcel", value: "DHLP" },
  { label: "Paack", value: "PAACK" }, 
  { label: "Propio", value: "PROPIO" },
];
